export default () => (s) => {
    s = (s === undefined || s === null) ? '' : s;
    return s.toString().replace(/([a-z](?=[A-Z]))/g, '$1 ');
};
